<div class="fe-capacities-container">
  <!-- SPINNER LAYER  -->
  <div class="spinner-container" *ngIf="spinnerBoolean">
    <div class="spinner"></div>
    <div class="spinner-text">Loading Gas Plant Capacities data...</div>
  </div>

  <!-- ACTION BAR -->
  <div class="table-actions-bar">
    <div class="table-title">Oil and Gas Capacities</div>
    <button *ngIf="hasAnyFilterApplied()" (click)="clearAllFilters()">Clear All</button>
    <button *ngIf="selectedRows.length > 0" (click)="clearSelection()">Clear Select</button>
    <button *ngIf="showCancel" (click)="cancelRow()">Cancel</button>
    <button (click)="addRow()">New</button>
    <button (click)="handleSave()" [disabled]="!data.length">Save</button>
    <button (click)="handleDelete()" [disabled]="!selectedRows.length">Delete</button>
    <button (click)="openExportDialog()" [disabled]="!data.length">Export</button>
  </div>

  <!-- <div *ngIf="dropdownLoading" class="dropdown-loading">
    Loading dropdown options...
  </div> -->

  <!-- TABLE CONTAINER -->
  <div class="table-container" [ngClass]="{ hidden: spinnerBoolean }">
    <div class="table-header-container">
      <div class="table-header-row">
        <div class="table-header-cell fixed-width-cell-1"></div>
        <div class="table-header-cell fixed-width-cell-2">Select</div>
        <div class="table-header-cell" *ngFor="let col of columns">
          <div class="col-wrap">
            <div class="text-wrap">
              {{ col.header }}
              <span *ngIf="col.required" class="required-asterisk" title="Required">*</span>
            </div>
            <div class="filter-icon-container" *ngIf="col.filterable">
              <img class="filter-icon" [ngClass]="{ 'active-filter': isFilterActive(col.field) }"
                [src]="isFilterActive(col.field) ? '../../assets/img/filtered.png' : '../../assets/img/Filter.png'"
                width="16" height="16" alt="Filter"
                [title]="isFilterActive(col.field) ? 'Filter applied - ' + col.header : 'Filter ' + col.header"
                (click)="openFloatingFilter($event, col.field)" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-body-container">
      <cdk-virtual-scroll-viewport itemSize="56" class="virtual-scroll-viewport"
        (scrolledIndexChange)="onScrolledIndexChange($event)">
        <div class="table-body-row" [ngClass]="{ 'new-row': row.isNew }" *cdkVirtualFor="let row of data; let i = index"
          (mouseenter)="hoveredRowIndex = i" (mouseleave)="hoveredRowIndex = null">
          <div class="table-header-cell fixed-width-cell-1">
            <span *ngIf="hoveredRowIndex === i" style="cursor: pointer; font-size: 16px" (click)="copyRow(i)"
              title="Copy this row">
              📋
            </span>
          </div>

          <div class="table-header-cell fixed-width-cell-2">
            <input type="checkbox" [checked]="selectedRows.includes(row)" (change)="toggleRowSelection(row, $event)" />
          </div>

          <!-- Facility Type -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select *ngIf="row.isNew" [(ngModel)]="row.assetType" 
                (ngModelChange)="onFacilityTypeChange(row, $event)">
                <option value="">-- Select Facility Type --</option>
                <option *ngFor="let type of getFacilityTypeOptionsForRow(row)" [value]="type">
                  {{ type }}
                </option>
              </select>
              <div *ngIf="!row.isNew" class="readonly-cell">
                {{ row.assetType || '-' }}
              </div>
            </div>
          </div>

          <!-- Development Area -->
          <!-- Development Area -->
          <div class="table-header-cell">
            <div class="cell-wrapper" [ngClass]="{ 'non-editable-field': (row.isNew && isGasPlantRow(row)) || !row.isNew }">
              <div *ngIf="(row.isNew && isGasPlantRow(row)) || !row.isNew" class="multi-facility-field">
                <div class="facility-tags">
                  <span *ngFor="let area of getDevelopmentAreaCards(row)" class="facility-chip">
                    {{ area }}
                  </span>
                  <span *ngIf="getDevelopmentAreaCards(row).length === 0" class="readonly-value">
                    -
                  </span>
                </div>
              </div>
              <select *ngIf="row.isNew && !isGasPlantRow(row)" [(ngModel)]="row.developmentArea" 
                (ngModelChange)="onDevelopmentAreaChange(row, $event)">
                <option value="">-- Select Development Area --</option>
                <optgroup label="Development Areas" class="dev-area-group">
                  <option *ngFor="let area of getDevelopmentAreaOptionsForRow(row)" [value]="area">
                    {{ area }}
                  </option>
                </optgroup>
                <optgroup label="Sub Development Areas" class="sub-dev-area-group">
                  <option *ngFor="let area of subDevelopmentAreaOptions" [value]="area">
                    {{ area }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>

          <!-- Facility Name -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select *ngIf="row.isNew" [(ngModel)]="row.facilityName" 
                (ngModelChange)="onFacilityNameChange(row, $event)">
                <option value="">-- Select Facility Name --</option>
                <option *ngFor="let facility of getFacilityNameOptionsForRow(row)" [value]="facility">
                  {{ facility }}
                </option>
              </select>
              <div *ngIf="!row.isNew" class="readonly-cell">
                {{ row.facilityName || '-' }}
              </div>
            </div>
          </div>

          <!-- Gas Take Away -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select *ngIf="row.isNew" [(ngModel)]="row.gasTakeAway" (ngModelChange)="handleEdit(row)">
                <option value="">-- Select Gas Take Away --</option>
                <option *ngFor="let option of gasTakeAwayOptions" [value]="option">
                  {{ option }}
                </option>
              </select>
              <div *ngIf="!row.isNew" class="readonly-cell">
                {{ row.gasTakeAway || '-' }}
              </div>
            </div>
          </div>

          <!-- Oil Take Away -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select *ngIf="row.isNew" [(ngModel)]="row.oilTakeAway" (ngModelChange)="handleEdit(row)"
                [disabled]="isGasPlantRow(row)">
                <option value="">-- Select Oil Take Away --</option>
                <option *ngFor="let option of oilTakeAwayOptions" [value]="option">
                  {{ option }}
                </option>
              </select>
              <div *ngIf="!row.isNew" class="readonly-cell">
                {{ row.oilTakeAway || '-' }}
              </div>
            </div>
          </div>

          <!-- Capacity Type -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <select *ngIf="row.isNew" [(ngModel)]="row.capacityType" (ngModelChange)="handleEdit(row)"
                [disabled]="isGasPlantRow(row)">
                <option value="">-- Select --</option>
                <option *ngFor="let type of capacityTypeOptions" [value]="type">
                  {{ type | titlecase }}
                </option>
              </select>
              <div *ngIf="!row.isNew" class="readonly-cell">
                {{ row.capacityType || '-' }}
              </div>
            </div>
          </div>

          <!-- Capacity -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <input type="number" [(ngModel)]="row.capacity" (input)="validateCapacity(row, $event)"
                placeholder="Enter capacity" />
            </div>
          </div>

          <!-- Effective Date -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <input type="date" [(ngModel)]="row.effective" (change)="handleEdit(row)" />
            </div>
          </div>

          <!-- Comment -->
          <div class="table-header-cell">
            <div class="cell-wrapper">
              <input type="text" [(ngModel)]="row.comment" (input)="onCommentChange(row, row.comment || '')"
                placeholder="Enter comment (optional)" maxlength="500" />
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>

  <div class="loading-more" *ngIf="loading">
    <div class="loading-spinner"></div>
    <span>Loading more data...</span>
  </div>

  <div class="floating-filter-dropdown" #floatingFilterPanel *ngIf="showFloatingFilter" [ngStyle]="{
      top: dropdownPosition.top + 'px',
      left: dropdownPosition.left + 'px'
    }">
    <!-- Multi-select filter (for facility type, dev area, facility name, capacity type) -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'multi-select'">
      <input type="text" [(ngModel)]="filterSearch[activeFilter]" placeholder="Search..." />

      <div *ngIf="isLoadingFilterOptions" class="filter-loading">
        <div class="spinner-small"></div>
        Loading options...
      </div>

      <div *ngIf="!isLoadingFilterOptions" class="filter-options">
        <div *ngIf="getFilterOptions(activeFilter).length === 0" class="no-options">
          No options available based on current filters
        </div>
        <div class="filter-options-count" *ngIf="getFilterOptions(activeFilter).length > 0">
          {{ getFilterOptions(activeFilter).length }} options available
        </div>
        <label *ngFor="let option of getFilterOptions(activeFilter)">
          <input type="checkbox" [checked]="isChecked(activeFilter, option)"
            (change)="toggleMultiFilter(activeFilter, option, $event)" />
          <span>{{ getFilterOptionLabel(option) }}</span>
        </label>
      </div>

      <div class="filter-buttons">
        <button (click)="applyFilter(activeFilter)">Apply</button>
        <button (click)="clearFilter(activeFilter)">Clear</button>
      </div>
    </ng-container>

    <!-- Date range filter (for effective date) -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'date-range'">
      <div class="date-range-filter">
        <label>Start Date:</label>
        <input type="date" [(ngModel)]="dateRangeFilters.startDate" placeholder="Start Date" />

        <label>End Date:</label>
        <input type="date" [(ngModel)]="dateRangeFilters.endDate" placeholder="End Date" />
      </div>

      <div class="filter-buttons">
        <button (click)="applyDateRangeFilter()">Apply</button>
        <button (click)="clearDateRangeFilter()">Clear</button>
      </div>
    </ng-container>

    <!-- Search filter (for capacity) -->
    <ng-container *ngIf="getFilterType(activeFilter) === 'search' && activeFilter === 'capacity'">
      <div class="search-filter">
        <label>Search Capacity:</label>
        <input type="text" [(ngModel)]="capacitySearchFilter" placeholder="Enter capacity value..."
          (keyup.enter)="applyCapacitySearch()" />
      </div>

      <div class="filter-buttons">
        <button (click)="applyCapacitySearch()">Apply</button>
        <button (click)="clearCapacitySearch()">Clear</button>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #deleteConfirmDialog>
  <div class="dialog-container">
    <h2 class="dialog-title">Confirm Delete</h2>
    <div class="dialog-content">
      <p>{{ dialogMessage }}</p>
    </div>
    <div class="dialog-actions">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
      <button class="delete-button" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #exportOptionsDialog>
  <div class="dialog-container export-dialog-container">
    <h2 class="dialog-title">Export Oil and Gas Capacities</h2>
    <div class="dialog-content export-dialog-content">
      <p>Select which data you want to download.</p>
    </div>
    <div class="export-dialog-actions">
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="exportToCSV()">Export Filtered</button>
      <button class="export-dialog-button" [mat-dialog-close]="true" (click)="downloadAllData()">Export All</button>
    </div>
    <div class="dialog-actions export-dialog-footer">
      <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    </div>
  </div>
</ng-template>